const config = require("config");

(function(angular) {
  angular
    .module("fleetviewApp")
    .service("LayoutService", LayoutService);

  LayoutService.$inject = [
    "$rootScope"
  ];

  function LayoutService($rootScope) {
    let leftPanelWidth = "0";

    const service = {
      getLeftPanelWidth: getLeftPanelWidth,
      openLeftHandPanel: openLeftHandPanel,
      closeLeftHandPanel: closeLeftHandPanel,
    };

    return service;

    function getLeftPanelWidth() {
      return leftPanelWidth;
    }

    function openLeftHandPanel(width) {
      leftPanelWidth = width;
    }

    function closeLeftHandPanel() {
      leftPanelWidth = "0";
    }
  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/layout/layoutService.js